import {ApiResourceContextType} from "./types";
import {useContext} from "react";
import {ApiResourceContext} from "./APIResourceContextProvider";

export const useApiResourceContext = (): ApiResourceContextType => {
  return useContext(ApiResourceContext)
}